var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoca(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "location-09"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.70987 17.7582C6.84354 18.1502 6.63409 18.5764 6.24204 18.7101C5.6599 18.9086 5.24693 19.121 4.99462 19.3179C4.79284 19.4754 4.75674 19.5699 4.75083 19.5923C4.75689 19.6151 4.79849 19.7302 5.06348 19.9187C5.37507 20.1404 5.87455 20.3708 6.55927 20.5769C7.91922 20.9861 9.843 21.2502 12 21.2502C14.157 21.2502 16.0808 20.9861 17.4407 20.5769C18.1255 20.3708 18.6249 20.1404 18.9365 19.9187C19.2015 19.7302 19.2431 19.6151 19.2492 19.5923C19.2433 19.5699 19.2071 19.4754 19.0054 19.3179C18.7531 19.121 18.3401 18.9086 17.758 18.7101C17.3659 18.5764 17.1565 18.1502 17.2901 17.7582C17.4238 17.3661 17.85 17.1567 18.242 17.2903C18.9046 17.5163 19.4916 17.7947 19.9282 18.1353C20.3545 18.468 20.75 18.9537 20.75 19.5927C20.75 20.2876 20.2851 20.8001 19.8061 21.1409C19.3081 21.4953 18.636 21.7836 17.873 22.0132C16.3375 22.4753 14.2613 22.7502 12 22.7502C9.73872 22.7502 7.6625 22.4753 6.12702 22.0132C5.36403 21.7836 4.69193 21.4953 4.19388 21.1409C3.71492 20.8001 3.25 20.2876 3.25 19.5927C3.25 18.9537 3.64545 18.4681 4.07183 18.1353C4.50834 17.7947 5.09537 17.5162 5.75796 17.2903C6.15002 17.1567 6.5762 17.3661 6.70987 17.7582Z",
    fill: "#053CC8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7.25C10.7573 7.25 9.75 8.25736 9.75 9.5C9.75 10.7427 10.7573 11.75 12 11.75C13.2427 11.75 14.25 10.7427 14.25 9.5C14.25 8.25736 13.2427 7.25 12 7.25ZM8.25 9.5C8.25 7.42894 9.92888 5.75 12 5.75C14.0711 5.75 15.75 7.42894 15.75 9.5C15.75 11.5711 14.0711 13.25 12 13.25C9.92889 13.25 8.25 11.5711 8.25 9.5Z",
    fill: "#053CC8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.75C8.36015 2.75 5.25 5.83749 5.25 9.5869C5.25 13.3802 8.38921 16.1117 11.6129 18.1496C11.7321 18.2156 11.8652 18.25 12 18.25C12.1354 18.25 12.269 18.2153 12.3885 18.1487C15.6124 16.1344 18.75 13.3676 18.75 9.5869C18.75 5.83749 15.6398 2.75 12 2.75ZM3.75 9.5869C3.75 5.01857 7.52225 1.25 12 1.25C16.4778 1.25 20.25 5.01857 20.25 9.5869C20.25 14.2513 16.4018 17.4121 13.1696 19.4294L13.1583 19.4365L13.1467 19.4432C12.7978 19.644 12.4027 19.75 12 19.75C11.5973 19.75 11.2022 19.644 10.8533 19.4432L10.84 19.4356L10.8271 19.4274C7.60753 17.3944 3.75 14.2671 3.75 9.5869Z",
    fill: "#053CC8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoca);
export default __webpack_public_path__ + "static/media/loca.09d4a262551fe330a1f926d682d82744.svg";
export { ForwardRef as ReactComponent };